import { MediaObjectsActionTypes } from '@store/mediaObjects'

export const clearMediaObjectErrors = () => ({
  type: MediaObjectsActionTypes.CLEAR_ERRORS,
})
